import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createPersona,
  fetchPersona,
  fetchPersonas,
  transitionPersona,
  updatePersona,
  type PersonaState,
} from "../api/personas";

export function usePersonas() {
  return useQuery({
    queryKey: ["personas"],
    queryFn: fetchPersonas,
  });
}

export function usePersona(id: string) {
  return useQuery({
    queryKey: ["persona", id],
    queryFn: () => fetchPersona(id),
    enabled: !!id,
  });
}

export function useCreatePersona() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { display_name: string; role: string; bio?: string; synthetic?: boolean }) =>
      createPersona(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["personas"] });
    },
  });
}

export function useUpdatePersona(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, unknown>) => updatePersona(id, body as never),
    onSuccess: (data) => {
      qc.setQueryData(["persona", id], data);
      void qc.invalidateQueries({ queryKey: ["personas"] });
    },
  });
}

export function useTransitionPersona(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { target_state: PersonaState; comment?: string }) =>
      transitionPersona(id, body),
    onSuccess: (data) => {
      qc.setQueryData(["persona", id], data);
      void qc.invalidateQueries({ queryKey: ["personas"] });
    },
  });
}
